module.exports = __webpack_public_path__ + "static/img/contact_logo6_h.b345301.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/contact_logo6_h.png
// module id = pYqp
// module chunks = 1